export type CommentItem = {
  id: string;
  name: string;
  email?: string;
  message: string;
  createdAt: string;
  parentId?: string;
};

const BASES = (typeof window !== 'undefined' && window.location && window.location.port === '3000')
  ? ['http://localhost:8000']
  : [''];

async function tryFetch(path: string, init?: RequestInit) {
  let last: any = null;
  for (const b of BASES) {
    const url = b ? `${b}${path}` : path;
    try {
      const res = await fetch(url, init);
      if (res.ok) return res;
      last = new Error(`HTTP ${res.status}`);
    } catch (e) { last = e; }
  }
  throw last || new Error('Network error');
}

async function parseJson(res: Response) {
  const ct = (res.headers.get('content-type') || '').toLowerCase();
  if (ct.includes('application/json')) return await res.json();
  const text = await res.text().catch(() => '');
  const snippet = text ? text.slice(0, 200) : '';
  throw new Error(`Expected JSON but got ${ct || 'unknown content-type'}${snippet ? `: ${snippet}` : ''}`);
}

export async function loadComments(slug: string): Promise<CommentItem[]> {
  const res = await tryFetch(`/get_comments.php?slug=${encodeURIComponent(slug)}`, { cache: 'no-store' });
  const data = await parseJson(res);
  return (data.items || []) as CommentItem[];
}

export async function addComment(slug: string, input: { name: string; email?: string; message: string; parentId?: string }): Promise<{ ok: boolean; comment?: CommentItem; error?: string; duplicate?: boolean }>{
  const body = JSON.stringify({ slug, ...input });
  const res = await tryFetch('/add_comment.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body });
  return parseJson(res);
}
